import apirecebimentoweb from '@/services/api-recebimentoweb';

export default {
  namespaced: true,

  state: {
    list: [],
    armazem: [],
    idlocalarmazenamento: null,
  },

  getters: {
    list: (state) => state.list,
    armazem: (state) => state.armazem,
  },

  actions: {
    async findControleArmazenamento(_, {
      where, ...params
    } = {}) {
      const { data } = await apirecebimentoweb.get('resultadosecagem/controlearmazenamento', { params: { ...where, ...params } });
      return { data };
    },

    async findArmazem({ commit }) {
      const { data } = await apirecebimentoweb.get('/localarmazenamento/codigo');
      commit('SET_ARMAZEM', data);
      return data;
    },

    async findPessoaDistinct(_, { where } = {}) {
      const { data } = await apirecebimentoweb.get('resultadosecagem/pessoa/distinct', { params: where });
      return { data };
    },

    async findPessoaDistinctCodigo(_, { codigo }) {
      const { data } = await apirecebimentoweb.get(`resultadosecagem/pessoa/distinct/${codigo}`);
      return { data };
    },

    async findPropriedadeDistinct(_, { where } = {}) {
      const { data } = await apirecebimentoweb.get('resultadosecagem/propriedade/distinct', { params: where });
      return { data };
    },

    async findPropriedadeDistinctCodigo(_, { codigo }) {
      const { data } = await apirecebimentoweb.get(`resultadosecagem/propriedade/distinct/${codigo}`);
      return { data };
    },
  },

  mutations: {
    SET_LIST(state, list) {
      state.list = list ?? [];
    },
    SET_ARMAZEM(state, armazem) {
      state.armazem = armazem ?? [];
    },
    SET_LOCAL(state, id) {
      state.idlocalarmazenamento = id ?? null;
    },
  },
};
